import { render, staticRenderFns } from "./PanelNewUi.vue?vue&type=template&id=b966fcfa&scoped=true&"
import script from "./PanelNewUi.vue?vue&type=script&lang=js&"
export * from "./PanelNewUi.vue?vue&type=script&lang=js&"
import style0 from "./PanelNewUi.vue?vue&type=style&index=0&id=b966fcfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b966fcfa",
  null
  
)

export default component.exports